import datatable from './app-config/datatable'

export default defineAppConfig({
  datatable,
})
